import axios from 'axios';
import { paths } from 'repositories/version/paths';
import { CheckResponse } from 'repositories/version/responseType';
import { getRequestPath } from 'utils/string';

const check = async (): Promise<CheckResponse> => {
  const response = await axios.get<CheckResponse>(
    getRequestPath(paths.version, { timestamp: new Date().getTime() })
  );
  return response.data;
};

// TODO version取得タイミングを30分に1度だけ取得する、という仕組みで使う予定なので残しておく
const timestamp = (now: Date): string => {
  const year = now.getFullYear();
  const month = ('0' + (now.getMonth() + 1)).slice(-2);
  const date = ('0' + now.getDate()).slice(-2);
  const hour = ('0' + now.getHours()).slice(-2);
  // 30分単位でtimestampを変更する
  const minutes = now.getMinutes() >= 30 ? '30' : '00';

  // YYYYMMDDhhmm のフォーマットにする
  return year + month + date + hour + minutes;
};

export const version = {
  check,
  timestamp,
};
